module.exports = __webpack_public_path__ + "img/t2-16.16e630fa.svg";